export { default } from './GlobalBanner';
